import React from 'react';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import './index.css';

const today = new Date();

class DataPicker extends React.Component{
  state = {
    selectedDate: null,
  }

  handleDayChange = (day) => {
    this.setState({ selectedDate: day });
  }

  handlerClose = () => {
    this.props.forClose();
  }

  handlerSave = () => {
    this.props.forSave(this.state.selectedDate);
  }

  render(){
    return (
      <div className="day-picker">
        <div className="day-picker__header">
          <p className="day-picker__start">
            Start date
          </p>
          <p className="day-picker__year">
            2018
          </p>
          <p className="day-picker__date">
            Thu, Apr 13
          </p>
        </div>
        <DayPicker className='day-picker__calendar' onDayClick={this.handleDayChange} disabledDays={{ before: today }}/>
        <div className="day-picker__buttons">
          <div className="day-picker__cancel" onClick={this.handlerClose}>Cancel</div>
          <div className="day-picker__ok" onClick={this.handlerSave}>Ok</div>
        </div>
      </div>
    );
  }
}

export default DataPicker;
